import React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { FaSchool } from "react-icons/fa";
import { FaUniversity } from "react-icons/fa";
import { FaBuilding } from "react-icons/fa";

const Experienc = () => {
  return (
    <>
      <section className="experience_section">
        <div className="container">
          <h2 className="about_main_heading">Education & Experience</h2>
          <div className="row">
            <div className="col-lg-12">
              <VerticalTimeline>
                <VerticalTimelineElement
                  className="vertical-timeline-element--work"
                  date="2015 - 2016"
                  iconStyle={{ background: "#72e2ae", color: "#fff" }}
                  icon={<FaSchool />}
                >
                  <h3 className="vertical-timeline-element-title">
                    Intermediate
                  </h3>

                  <p>
                    Saraswati Vidhya Mandir Senior Secondry School, Etah 207001
                  </p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                  className="vertical-timeline-element--work"
                  date="2016 - 2020"
                  iconStyle={{ background: "#72e2ae", color: "#fff" }}
                  icon={<FaUniversity />}
                >
                  <h3 className="vertical-timeline-element-title">
                    Bachelor of Technology{" "}
                  </h3>
                  <h4 className="vertical-timeline-element-subtitle">
                    Computer Science
                  </h4>
                  <p>FET Agra college Agra(AKTU)</p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                  className="vertical-timeline-element--work"
                  date="May 2019 - July 2019"
                  iconStyle={{ background: "#72e2ae", color: "#fff" }}
                  icon={<FaBuilding />}
                >
                  <h3 className="vertical-timeline-element-title">
                    Website Developer
                  </h3>

                  <p>JavatPoint (Noida)</p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                  className="vertical-timeline-element--work"
                  date="July 2021 - Oct 2022"
                  iconStyle={{ background: "#72e2ae", color: "#fff" }}
                  icon={<FaBuilding />}
                >
                  <h3 className="vertical-timeline-element-title">
                    Frontend Developer
                  </h3>

                  <p>Dynamisers Solutions Private Limited (Delhi)</p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                  className="vertical-timeline-element--work"
                  date="Nov 2022 - Apr 2024"
                  iconStyle={{ background: "#72e2ae", color: "#fff" }}
                  icon={<FaBuilding />}
                >
                  <h3 className="vertical-timeline-element-title">
                    Frontend Developer/App Developer
                  </h3>

                  <p>Isynbus Technology Private Limited (Noida)</p>
                </VerticalTimelineElement>
              </VerticalTimeline>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6"></div>
            <div className="col-lg-6"></div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Experienc;
